import {
  Reveal,
  RevealText,
  Stagger,
  StaggerItem,
} from "@project/user/components/motion";
import { useI18n } from "@project/lib/use-i18n";
import award1 from "@project/assets/awards/award-1.png";
import award2 from "@project/assets/awards/award-2.png";
import award3 from "@project/assets/awards/award-3.png";
import award4 from "@project/assets/awards/award-4.png";

const awards = [
  { key: "a1", image: award1 },
  { key: "a2", image: award2 },
  { key: "a3", image: award3 },
  { key: "a4", image: award4 },
];

export function AwardsSection({ className = "" }: { className?: string }) {
  const { t } = useI18n();

  return (
    <section className={className}>
      <div className="mx-auto max-w-site px-4 py-16">
        <div className="text-center">
          <Reveal variant="zoom">
            <div className="ornament mb-4" aria-hidden>
              <span className="ornament-dot" />
            </div>
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-primary">
              {t("home.awards.eyebrow")}
            </p>
          </Reveal>
          <h2 className="mt-3 font-serif text-3xl font-semibold tracking-tight text-foreground md:text-4xl">
            <RevealText delay={120}>
              {t("home.awards.headingBefore")}{" "}
              {t("home.awards.headingHighlight")}
            </RevealText>
          </h2>
          <Reveal variant="fade" delay={260}>
            <p className="mx-auto mt-3 max-w-2xl text-muted-foreground">
              {t("home.awards.description")}
            </p>
          </Reveal>
        </div>

        <Stagger
          step={130}
          delay={150}
          className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4"
        >
          {awards.map((a, i) => (
            <StaggerItem key={a.key} index={i} from="zoom">
              <article className="card-lift group flex h-full flex-col overflow-hidden rounded-2xl  bg-card shadow-lg">
                <div className="relative grid h-56 place-items-center bg-gradient-to-b from-secondary to-card px-6 pt-6">
                  <div
                    className="pointer-events-none absolute left-1/2 top-1/2 h-32 w-32 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#efa93133] blur-2xl"
                    aria-hidden
                  />
                  <img
                    src={a.image}
                    alt={t(`home.awards.${a.key}Title`)}
                    loading="lazy"
                    decoding="async"
                    className="relative h-44 w-[55%] object-contain drop-shadow-[0_12px_14px_rgba(0,0,0,0.25)] transition-transform duration-500 group-hover:-translate-y-1.5 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col items-center px-5 pb-6 pt-5 text-center">
                  <h3 className="!text-[1.18rem] !font-sans !leading-snug text-foreground">
                    {t(`home.awards.${a.key}Title`)}
                  </h3>
                  <span className="mt-3 h-0.5 w-10 rounded-full bg-gold" />
                  <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                    {t(`home.awards.${a.key}Desc`)}
                  </p>
                </div>
              </article>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
